import React from "react";
import "./CardUI.css";

const CardUI = props =>{
    const technologies = props.technologies.map((t, i) => {
        return(
            <span key={i} className="px-1 technology">
                {t}
            </span>
        );
    });

    return (
      <div className="card text-center shadow h-100">
        <div className="overflow">
            <a  target="_blank" rel="noopener noreferrer" href={props.demo}>
            <img src={props.imgsrc} alt={props.title} className="card-img-top"/>
            </a>
        </div>
        <div className="card-body text-dark">
          <h4 className="card-title">{props.title}</h4>
          <p className="card-text text-secondary">
              {props.description}
          </p>
            <div className="d-flex justify-content-center pb-3">
                {props.demo && <a  target="_blank" rel="noopener noreferrer" className="px-2" href={props.demo}>Demo</a>}
            <a  target="_blank" rel="noopener noreferrer" className="px-2" href={props.page}>See more</a>
            </div>
            <div className="d-flex justify-content-center">
                {technologies}
            </div>
        </div>
      </div>
  );
}

export default CardUI;



// WEBPACK FOOTER //
// ./src/CardUI/CardUI.js